import React from "react";
import styles from '../../styles/section/Main1.module.css';

const One = ( props ) => {

    return (
        <>
            <div  className={`${styles.section}`}>
                <img
                src={`${process.env.PUBLIC_URL}/main/1p/1p_수정2.gif`}
                className={styles.video}
                alt="Section 1" />

                <div className={`${styles.textBox}`}>
                    <div className={`${styles.text1} ${styles.textS} ${styles.sliders}`}>
                        <p>기업의 가치를 같이 만들어 나가는</p>
                    </div>
                    <div className={`${styles.logo} ${styles.sliders}`}>
                        <img 
                        src={`${process.env.PUBLIC_URL}/main/2p/2p-오퍼그룹로고_수정.png`} 
                        alt="Logo"/>
                    </div>
                    <div className={`${styles.text2} ${styles.textS} ${styles.sliders}`}>
                        <p><span className={styles.textSmall}>비즈니스 맞춤 성공전략으로 타깃 서비스를 공략합니다.</span></p>
                        <p><span className={styles.textSmall}>국내 최초 BNPL 서비스 파트너, </span>
                        <span className={styles.textLarge}>동반 성장 기업 오퍼그룹</span></p>
                    </div>
                </div>
            </div>
        </>
    )
};

export default One;